 "use client"

import dynamic from "next/dynamic"

// Client-only wrapper around the Lab ChatWidget so we can
// use `ssr: false` safely without putting it in a server layout.
const ChatWidgetInner = dynamic(
  () => import("@/modules/lab/chatbot/components/ChatWidget").then((mod) => mod.ChatWidget),
  { ssr: false },
)

export function MarketingChatWidget() {
  return <ChatWidgetInner />
}

export default MarketingChatWidget

